export default 'https://avfreex24.com/';
